import { render } from "./ProductDetail.vue?vue&type=template&id=dbc139de&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=dbc139de&scoped=true&lang=scss"
import "./ProductDetail.vue?vue&type=style&index=1&id=dbc139de&lang=scss"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc139de"]])

export default __exports__